<template>
  <div class="parc-data-data-tables">
    <b-button
      class="me-2 my-2 rounded pdf-btn"
      variant="success"
      size="sm"
      icon
      id="pdf-btn"
      @click="onClickPdf"
    >
      <b-spinner small label="Small Spinner" v-if="loading"></b-spinner>
      <i class="ti-printer pdf-btn_icon" v-else></i>
      <b-tooltip target="#pdf-btn">
        Générer un fichier PDF imprimable
      </b-tooltip>
    </b-button>
    <div id="data-overview">
      <div v-if="parc">
        <h3 class="mt-1">Parc</h3>
        <hr class="mt-1" />
        <b-table-simple
          small
          caption-top
          responsive
          bordered
          ligth
          :fixed="isFixedColumnWidth"
          class="data-table"
        >
          <b-thead variant="dark">
            <b-tr>
              <b-th>Identifiant</b-th>
              <b-th>Nom usuel</b-th>
              <b-th>Régime ICPE</b-th>
              <b-th>Statut</b-th>
              <b-th>Etat</b-th>
              <b-th>Raison sociale</b-th>
              <b-th>Siret</b-th>
              <b-th>Nombre d'éoliennes</b-th>
              <b-th>Nombre de poste(s) de livraison</b-th>
              <b-th>Renouvellement</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>
                <span v-if="parc.id">
                  {{ parc.id }}
                </span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.nomUsuel"> {{ parc.nomUsuel }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.statutAdministratif">
                  {{ parc.statutAdministratif.libelle }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.statutParc">
                  {{ parc.statutParc.libelle }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.etatParc"> {{ parc.etatParc.libelle }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.raisonSociale"> {{ parc.raisonSociale }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.siret"> {{ parc.siret }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.nombreAerogenerateur">
                  {{ parc.nombreAerogenerateur }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.nombrePosteLivraison">
                  {{ parc.nombrePosteLivraison }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="parc.renouvellement == false"> non</span>
                <span v-else-if="parc.renouvellement == true"> oui</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-row>
          <b-col class="communes">
            * Commune(s) d'implantation :
            <span v-if="parc.inventaireCommunes.length > 0">
              <span
                v-for="(commune, index) in parc.inventaireCommunes"
                :key="index"
              ><span v-if="index != 0">, </span>{{ commune.nomCommune }}</span
              >
            </span>
            <span v-else> {{ emptyField }}</span>
          </b-col>
        </b-row>
        <h3 class="mt-4">Dates clés du parc initial</h3>
        <hr class="mt-1"/>
        <b-table-simple
          small
          caption-top
          responsive
          bordered
          ligth
          :fixed="isFixedColumnWidth"
          class="data-table"
        >
          <b-thead variant="dark">
            <b-tr>
              <b-th v-if="isDeclaration"
                >Délivrance du récépissé de déclaration par la préfecture</b-th
              >
              <b-th v-if="isAutorisation"
                >Dépôt du dossier de demande d'autorisation</b-th
              >
              <b-th v-if="isAutorisation"
                >Délivrance de l'avis de l'autorité environnementale</b-th
              >
              <b-th v-if="isRejet">Arrêté de rejet</b-th>
              <b-th v-if="isAutorisation && !isRejet">Arrêté d'autorisation ICPE</b-th>
              <b-th v-if="isRefus">Arrêté de refus</b-th>
              <b-th v-if="!isRefus && !isRejet">Déclaration d'ouverture du chantier de construction</b-th>
              <b-th v-if="!isRefus && !isRejet">Mise en service</b-th>
              <b-th v-if="!isRefus && !isRejet">Déclaration d’ouverture du chantier de démantèlement</b-th>
              <b-th v-if="!isRefus && !isRejet">Cessation d'activité</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td v-if="isDeclaration">
                <span v-if="parc.dateDelivranceRecipissePrefecture">
                  {{
                    $filters.formatDate(parc.dateDelivranceRecipissePrefecture)
                  }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="isAutorisation">
                <span v-if="parc.dateDepotDemandeAutorisation">
                  {{ $filters.formatDate(parc.dateDepotDemandeAutorisation) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="isAutorisation">
                <span v-if="parc.dateDelivranceAvisAutoriteEnvironnementale">
                  {{
                    $filters.formatDate(parc.dateDelivranceAvisAutoriteEnvironnementale)
                  }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="isRejet">
                <span v-if="parc.dateDelivranceRejet">
                  {{ $filters.formatDate(parc.dateDelivranceRejet) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="isAutorisation && !isRejet">
                <span v-if="parc.dateDelivranceAutorisation">
                  {{ $filters.formatDate(parc.dateDelivranceAutorisation) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="isRefus">
                <span v-if="parc.dateDelivranceRefus">
                  {{ $filters.formatDate(parc.dateDelivranceRefus) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="!isRefus && !isRejet">
                <span v-if="parc.dateDebutConstruction">
                  {{ $filters.formatDate(parc.dateDebutConstruction) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="!isRefus && !isRejet">
                <span v-if="parc.dateMiseEnService">
                  {{ $filters.formatDate(parc.dateMiseEnService) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="!isRefus && !isRejet">
                <span v-if="parc.dateDebutDemantelement">
                  {{ $filters.formatDate(parc.dateDebutDemantelement) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td v-if="!isRefus && !isRejet">
                <span v-if="parc.dateCessationActivite">
                  {{ $filters.formatDate(parc.dateCessationActivite) }}</span
                >
                <span v-else> {{ emptyField }}</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <!-- {{ renouvellements }} -->
      <div class="mt-4" v-if="isRenouvellement">
        <div v-for="(renouvellement, index) in renouvellements">
          <h3>Dates clés du renouvellement #{{ index + 1 }}</h3>
          <hr class="mt-1"/>
          <ParcProfileParcCardRenouvellementListTable
            :renouvellements="[renouvellement]"
            :isEditable="false"
            :emptyField="emptyField"
          />
        </div>
      </div>
      <div class="mt-4" v-if="isEoliennes && !isRefus && !isRejet">
        <h3>Eoliennes</h3>
        <hr class="mt-1" />
        <!-- {{ eoliennes }} -->
        <b-table-simple
          small
          caption-top
          responsive
          bordered
          ligth
          class="data-table"
        >
          <b-thead variant="dark">
            <b-tr>
              <b-th>Identifiant</b-th>
              <b-th>Puissance installée (MW)</b-th>
              <b-th>Période d'allumage</b-th>
              <b-th>Type de feu</b-th>
              <b-th>Constructeur</b-th>
              <b-th>Référence</b-th>
              <b-th>Côte NGF au sol (m)</b-th>
              <b-th>Hauteur en bout de pale (m)</b-th>
              <b-th>Hauteur mât + nacelle (m)</b-th>
              <b-th>Diamètre du rotor (m)</b-th>
              <b-th>X ({{ parc.projection.libelle }})</b-th>
              <b-th>Y ({{ parc.projection.libelle }})</b-th>
              <b-th>Commune d'implantation</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="eolienne in eoliennes" :key="eolienne.id">
              <b-td>
                <span v-if="eolienne.id">{{ eolienne.id }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.puissance">{{ eolienne.puissance }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.periodeAllumage">{{
                  eolienne.periodeAllumage.libelle
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.typeFeu">{{
                  eolienne.typeFeu.libelle
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.constructeur">{{
                  eolienne.constructeur.nom
                }}</span>
                <span v-else-if="eolienne.constructeurAutre">{{
                  eolienne.constructeurAutre
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.referenceModele">{{
                  eolienne.referenceModele.referenceCommerciale
                }}</span>
                <span v-else-if="eolienne.referenceAutre">{{
                  eolienne.referenceAutre
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.coteNgf">{{ eolienne.coteNgf }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.hauteurTotale">{{
                  eolienne.hauteurTotale
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.hauteurMatNacelle">{{
                  eolienne.hauteurMatNacelle
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.diametreRotor">{{
                  eolienne.diametreRotor
                }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.xaerogenerateur">
                  {{ eolienne.xaerogenerateur.toFixed(6) }}
                </span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.yaerogenerateur">
                  {{ eolienne.yaerogenerateur.toFixed(6) }}
                </span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="eolienne.inventaireCommune">
                  {{ eolienne.inventaireCommune.nomCommune }}
                </span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <div class="mt-4" v-if="isPostesLivraison && !isRefus && !isRejet">
        <h3>Postes de livraison</h3>
        <hr class="mt-1" />
        <!-- {{ postesLivraison }} -->
        <b-table-simple small caption-top responsive fixed bordered ligth>
          <b-thead variant="dark">
            <b-tr>
              <b-th>Identifiant</b-th>
              <b-th>X ({{ parc.projection.libelle }})</b-th>
              <b-th>Y ({{ parc.projection.libelle }})</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="postesLivraison in postesLivraison"
              :key="postesLivraison.id"
            >
              <b-td>
                <span v-if="postesLivraison.id">{{ postesLivraison.id }}</span>
                <span v-else> {{ emptyField }}</span>
              </b-td>

              <b-td>
                <span v-if="postesLivraison.xposteLivraison">
                  {{ postesLivraison.xposteLivraison }}
                </span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
              <b-td>
                <span v-if="postesLivraison.yposteLivraison">
                  {{ postesLivraison.yposteLivraison }}
                </span>
                <span v-else> {{ emptyField }}</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

import {parcService} from "@/service/parc.service.js";
import ParcProfileParcCardRenouvellementListTable from "@/components/ParcProfileParcCardRenouvellementListTable.vue";
import {BButton, BCol, BRow, BSpinner, BTableSimple, BTbody, BTd, BTh, BThead, BTooltip, BTr} from "bootstrap-vue-next";

export default {
  components: {
    BTooltip,
    ParcProfileParcCardRenouvellementListTable,
    BTableSimple,
    BButton,
    BSpinner,
    BThead, BTr, BTh, BTbody, BTd,
    BCol, BRow
  },
  data() {
    return {
      emptyField: "Non renseigné",
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      parc: "parc",
      eoliennes: "eoliennes",
      postesLivraison: "postesLivraison",
      renouvellements: "renouvellements",
      isEoliennes: "isEoliennes",
      isPostesLivraison: "isPostesLivraison",
      isRenouvellement: "isRenouvellement",
      isRejet: "isRejet",
      isRefus: "isRefus",
      isAutorisation: "isAutorisation",
      isDeclaration: "isDeclaration",
    }),
    isFixedColumnWidth() {
      return window.innerWidth > 1103;
    }
  },
  methods: {
    onClickPdf() {
      this.loading = true;
      const parcId = this.parc.id;
      parcService.getParcReport(parcId).then(response => {
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
      });
    },
    formatDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let minutes = date.getMinutes();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (minutes < 10) minutes = "0" + minutes;

      return (
        [day, month, date.getFullYear()].join("/") +
        " " +
        [date.getHours(), minutes].join(":")
      );
    },
    fileTitleFormatDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      return [date.getFullYear(), month, day].join(".");
    }
  }
};
</script>

<style lang="scss">
.parc-data-data-tables {
  h3 {
    font-size: 1.5em;
  }
  thead tr th {
    font-size: 0.7em !important;
  }

  tbody tr td {
    font-size: 0.7em;
  }

  .communes {
    font-size: 0.8em;
    span {
      font-size: 0.9em;
    }
  }

  .data-table {
    overflow: auto;
  }

  .pdf-btn {
    position: absolute;
    top: -55px;
    right: 36px;

    @media screen and (max-width: 1005px) {
      top: unset;
      bottom: -62px;
      right: 106px;
    }
  }
}
</style>
